import React, { useState } from "react";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

import "./ForgotPassword.css";

let langData = require("../../../Data/language.json");

export default function ForgotPassword(props) {
  const [email, setEmail] = useState("");

  return (
    <div className="container-fluid col-lg-8 col-md-11 col-sm-11">
      <Paper
        className="container-fluid"
        id="logInContainer"
        elevation={6}
        square
      >
        <div className="inputWrapper">
          <h3>{langData[props.language].forgotPassword.title}</h3>
          <TextField
            className="emailInput"
            id="outlined-email-input"
            label={langData[props.language].forgotPassword.email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            name="email"
            margin="normal"
            variant="outlined"
          />
          <br />
          <p>{props.errorTxt}</p>
          <Button
            variant="outlined"
            onClick={() => props.onForgotPassword(email)}
          >
            {langData[props.language].forgotPassword.resetBtn}
          </Button>
          <br />
          <hr />
          <Button
            variant="outlined"
            onClick={() => props.toggleInputMode("login")}
          >
            {langData[props.language].forgotPassword.backBtn}
          </Button>
        </div>
      </Paper>
    </div>
  );
}
